var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVibration = function SvgVibration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 3,
    width: 12,
    height: 18,
    rx: 1,
    stroke: "#2196F3",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 7,
    width: 4,
    height: 5,
    rx: 1,
    stroke: "#2196F3",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.832 8A9.966 9.966 0 0 0 1 12c0 1.422.297 2.775.832 4",
    stroke: "#2196F3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.168 8A9.966 9.966 0 0 1 23 12a9.966 9.966 0 0 1-.832 4",
    stroke: "#248BF2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
export { SvgVibration as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect x='6' y='3' width='12' height='18' rx='1' stroke='%232196F3' stroke-width='2'/%3E %3Crect x='10' y='7' width='4' height='5' rx='1' stroke='%232196F3' stroke-width='2'/%3E %3Cpath d='M1.83209 8C1.2969 9.22492 1 10.5778 1 12C1 13.4222 1.2969 14.7751 1.83209 16' stroke='%232196F3' stroke-width='2' stroke-linecap='round'/%3E %3Cpath d='M22.1679 8C22.7031 9.22492 23 10.5778 23 12C23 13.4222 22.7031 14.7751 22.1679 16' stroke='%23248BF2' stroke-width='2' stroke-linecap='round'/%3E %3C/svg%3E";